// extracted by mini-css-extract-plugin
export var component = "JournalIssueSignpost-module--component--722c3";
export var contents = "JournalIssueSignpost-module--contents--8155f";
export var fadePop = "JournalIssueSignpost-module--fade-pop--4883d";
export var growHeightIn = "JournalIssueSignpost-module--grow-height-in--dad5d";
export var image = "JournalIssueSignpost-module--image--9a5fb";
export var noImage = "JournalIssueSignpost-module--noImage--db92f";
export var withImage = "JournalIssueSignpost-module--withImage--5eca0";